import Vue from 'vue'
import Vuex from 'vuex'
// import account from './modules/account'
import setting from './modules/setting'
import homework from './modules/homework'
import homeworkEnd from './modules/homeworkEnd'
import examInfos from './modules/exam'
// import class from './modules/class'
// import modal from './modules/modal'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    routeData: {},
    isLogin: false,
    teacherMenu: [],
    educationMenu: []
  },
  getters: {
    getuser (state) {
      return state.userInfo
    },
    getroute (state) {
      return state.routeData;
    },
    getIsLogin (state) {
      return state.isLogin;
    }
  },
  mutations: {
    setUser (state, user) {
      state.userInfo = user
    },
    setRoute (state, route) {
      state.routeData = route;
    },
    setIsLogin (state, isLogin) {
      state.isLogin = isLogin;
    },
    setTeacherMenu (state, teacherMenu) {
      state.teacherMenu = teacherMenu
    },
    setEducationMenu (state, educationMenu) {
      state.educationMenu = educationMenu
    }
  },
  modules: {
    //account,
    setting,
    homework,
    homeworkEnd,
    examInfos
    // ,
    // class
    // modal,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js